module.exports = __webpack_public_path__ + "static/media/empty-cart.302b7b48.svg";